import type { ContextMenuItem } from "@cmmd-forge/contracts";
import type { SidebarProjectSourceMetadata } from "./SidebarProjectItem";

export type SidebarProjectContextMenuAction =
  | "link-cmmd"
  | "copy-path"
  | "archive-all-threads"
  | "delete";

export interface SidebarProjectRuntimeActionPolicy {
  readonly canCreateThread: boolean;
  readonly createThreadTitle: string;
  readonly createThreadDescription: string;
  readonly createThreadAriaDisabled: boolean;
  readonly contextMenuItems: readonly ContextMenuItem<SidebarProjectContextMenuAction>[];
}

export function resolveSidebarProjectRuntimeActionPolicy(input: {
  readonly projectName: string;
  readonly source: SidebarProjectSourceMetadata;
}): SidebarProjectRuntimeActionPolicy {
  const routeAvailable = input.source.actionRouteAvailable;
  const canExposeLocalPath = !input.source.hideLocalPath;
  const contextMenuItems: ContextMenuItem<SidebarProjectContextMenuAction>[] = [];

  if (canExposeLocalPath) {
    contextMenuItems.push({
      id: "link-cmmd",
      label: input.source.linkState === "linked" ? "Edit CMMD link" : "Link to CMMD project",
    });
    contextMenuItems.push({ id: "copy-path", label: "Copy Project Path" });
  }

  if (routeAvailable) {
    contextMenuItems.push({ id: "archive-all-threads", label: "Archive all threads" });
  }

  contextMenuItems.push({
    id: "delete",
    label: routeAvailable ? "Remove project" : input.source.actionRouteLabel,
    destructive: true,
    disabled: !routeAvailable,
  });

  return {
    canCreateThread: routeAvailable,
    createThreadTitle: routeAvailable
      ? `Create new thread in ${input.projectName}`
      : input.source.actionRouteLabel,
    createThreadDescription: routeAvailable ? "New thread" : input.source.actionRouteDescription,
    createThreadAriaDisabled: !routeAvailable,
    contextMenuItems,
  };
}
